import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { CloseCircle } from 'asset';

interface Props {
  open: boolean;
  onClosePopup: () => void;
  onConfirmGen: () => void;
}

const PopupConfirmGenerateJob = (props: Props) => {
  const { open, onClosePopup, onConfirmGen } = props;

  return (
    <Dialog
      open={open}
      onClose={onClosePopup}
      sx={{
        '& .MuiPaper-root': {
          width: 450,
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          padding: '20px 25px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '18px',
            lineHeight: '100%',
            color: '#000',
          }}
        >
          Creating job with insufficient credit
        </Typography>
        <IconButton
          onClick={onClosePopup}
          sx={{
            padding: 0,
          }}
        >
          <CloseCircle />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          p: '20px 25px',
        }}
      >
        <Typography
          sx={{
            fontSize: '14px',
            lineHeight: '20px',
            color: '#666666',
          }}
        >
          Not enough credit to cover full job charge. Outstanding amount created
          as extension pending payment. Proceed?
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          padding: '16px 25px 20px',
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          sx={{
            width: '100%',
          }}
        >
          <Button
            variant="outlined"
            color="secondary"
            onClick={onClosePopup}
            sx={{ flex: 1, height: '36px' }}
          >
            NO
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={onConfirmGen}
            sx={{ flex: 1, height: '36px' }}
          >
            YES
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default PopupConfirmGenerateJob;
